<div class="flex flex-col">
  @if (filterable || (isDocumentsTab && selectable)) {
    <div class="flex flex-end gap-4 ml-auto pb-4">
      @if (filterable && showClearFiltersButton) {
        <button
          pButton
          icon="pi pi-filter-slash"
          severity="secondary"
          (click)="clearFilters()"
        >
          Clear All Filters
        </button>
      }
      <div class="divider"></div>
      @if (isDocumentsTab && selectable && showDownloadButton) {
        <button
          pButton
          [disabled]="selectedDocumentIds?.length === 0"
          (click)="downloadDocs()">
          <i class="pi pi-download pr-2"></i>
          Download Document(s)
        </button>
      }
      <!-- to add if rowdata.count >0 then only visible -->
      @if (encryptedLinkAvailable && isValidDocumentAvailable()) {
        <button
          class="p-button"
          pButton
          (click)="viewICASummary()">
          <i class="pi pi-external-link pr-2"></i>
          View ICA Summary
        </button>
      }
    </div>
  }
</div>
<div aria-label="documents-list">
  <p-table
    #dt
    class="frozen-columns-table"
    currentPageReportTemplate="Showing {first} - {last} of {totalRecords} items"
    paginatorDropdownAppendTo="body"
    responsiveLayout="scroll"
    [paginator]="faxDocs?.length > 5"
    [rows]="5"
    [rowsPerPageOptions]="[5, 10, 15]"
    [rowSelectable]="isRowSelectable"
    [scrollable]="true"
    [showCurrentPageReport]="true"
    [value]="faxDocs"
    [(selection)]="fileSelected"
    (onHeaderCheckboxToggle)="allSelectedUpdated($event)"
    (onRowSelect)="onServicesRowChange()"
    (onRowUnselect)="onServicesRowChange()"
    >
    <ng-template pTemplate="header">
      <tr>
        <!-- Checkboxes -->
        @if (selectable) {
          <th alignFrozen="left" pFrozenColumn [frozen]="true"></th>
        }
        <!-- File Name -->
        <th alignFrozen="left" pFrozenColumn style="min-width: 20rem" [frozen]="true">File Name</th>
        <!-- Document Type: Send Fax Display -->
        @if (isFaxDisplay) {
          <th style="width: 15rem">Document Type</th>
        }
        <!-- Source -->
        <th style="min-width: 9rem">Source</th>
        <!-- Line Number -->
        <th style="min-width: 9rem">Line Number</th>
        <!-- Document Type: Document List Display -->
        @if (!isFaxDisplay) {
          <th style="width: 15rem">Document Type</th>
        }
        <!-- Description -->
        @if (!isFaxDisplay) {
          <th style="width: 15rem">Description</th>
        }
        <!-- Provider Type -->
        @if (isFaxDisplay) {
          <th style="width: 15rem">Provider Type</th>
        }
        <!-- Document Received Date/Time -->
        <th style="min-width: 19rem">{{dateColumnLabel}}</th>
        <!-- Created By -->
        @if (!isExternal) {
          <th style="min-width: 10rem;">Created By</th>
        }
        <!-- Document Checked -->
        @if (showChecked) {
          <th style="width: 16rem">Document Checked</th>
        }
        <!-- Preview/Delete -->
        <th style="width: 12rem">&nbsp;</th>
        <!-- Send to ocr-->
        <th style="width: 12rem">&nbsp;</th>
      </tr>
      @if (filterable) {
        <tr class="header-filter">
          <!-- Checkboxes -->
          @if (selectable) {
            <th alignFrozen="left" pFrozenColumn [frozen]="true">
              <p-tableHeaderCheckbox [value]="allSelected"></p-tableHeaderCheckbox>
            </th>
          }
          <!-- File Name -->
          <th alignFrozen="left" pFrozenColumn [frozen]="true">
            <p-iconfield>
              <input
                pInputText
                type="text"
                placeholder="Search"
                class="w-full"
                [(ngModel)]="appliedFilters.documentFileName.value"
                (input)="filterTable($event.target.value, 'documentFileName', 'contains')"
              />
              @if (appliedFilters.documentFileName.value) {
                <p-inputicon class="pi pi-times cursor-pointer" (click)="filterTable('', 'documentFileName', '')"/>
              }
            </p-iconfield>
          </th>
            <!-- Source -->
            <th>
              <p-multiSelect
                appendTo="body"
                placeholder="Filter"
                scrollHeight="200px"
                styleClass="p-column-filter"
                [options]="documentSourceList"
                [(ngModel)]="appliedFilters.documentSource.value"
                (onChange)="filterTable($event.value, 'documentSource', 'in')"
                >
                <ng-template let-option pTemplate="item">
                  <div class="p-multiselect-representative-option">
                    <span class="ml-1">{{option.value}}</span>
                  </div>
                </ng-template>
              </p-multiSelect>
            </th>
            <!-- Line Number -->
            <th></th>
            <!-- Document Type: Document List Display -->
            <th>
              <p-multiSelect
                appendTo="body"
                placeholder="Filter"
                placeholder="Filter"
                scrollHeight="200px"
                styleClass="p-column-filter"
                [options]="documentTypeList"
                [(ngModel)]="appliedFilters.documentType.value"
                (onChange)="filterTable($event.value, 'documentType', 'docType')"
                >
                <ng-template let-option pTemplate="item">
                  <div class="p-multiselect-representative-option">
                    <span class="ml-1">{{option.value}}</span>
                  </div>
                </ng-template>
              </p-multiSelect>
            </th>
            <!-- Description -->
            <th>
              <p-iconfield>
                <input
                  pInputText
                  type="text"
                  placeholder="Search"
                  [(ngModel)]="appliedFilters.documentDescription.value"
                  (input)="filterTable($event.target.value, 'documentDescription', 'contains')"
                />

                @if (appliedFilters.documentDescription.value) {
                  <p-inputicon class="pi pi-times cursor-pointer" (click)="filterTable('','documentDescription', '')" />
                }
              </p-iconfield>
            </th>
              <!-- Document Received Date/Time -->
              <th>
                <p-date-picker
                  #dateRangeFilter
                  appendTo="body"
                  dateFormat="mm/dd/yy"
                  placeholder="mm/dd/yyyy - mm/dd/yyyy"
                  selectionMode="range"
                  styleClass="p-column-filter"
                  [showButtonBar]="true"
                  [showIcon]="true"
                  [(ngModel)]="appliedFilters.dateTimeFaxReceived.value"
                  (ngModelChange)="filterTable(appliedFilters.dateTimeFaxReceived.value, 'dateTimeFaxReceived', 'customDate')"
                  (onClose)="validateSelectedDates()"
                ></p-date-picker>
              </th>
              <!-- Created By -->
              @if (!isExternal) {
                <th>
                  <p-multiSelect
                    appendTo="body"
                    placeholder="Filter"
                    scrollHeight="200px"
                    styleClass="p-column-filter"
                    [options]="createdByList"
                    [(ngModel)]="appliedFilters.createdBy.value"
                    (onChange)="filterTable($event.value, 'createdBy', 'in')"
                    >
                    <ng-template let-option pTemplate="item">
                      <div class="p-multiselect-representative-option">
                        <span class="ml-1">{{option.label}}</span>
                      </div>
                    </ng-template>
                  </p-multiSelect>
                </th>
              }
              <!-- Document Checked -->
              @if (showChecked) {
                <th>
                  <p-multiSelect
                    appendTo="body"
                    placeholder="Filter"
                    scrollHeight="200px"
                    styleClass="p-column-filter"
                    [options]="documentCheckedOptions"
                    [(ngModel)]="appliedFilters.checkedByUserName.value"
                    (onChange)="filterTable($event.value, 'checkedByUserName', 'documentChecked')"
                    >
                    <ng-template let-option pTemplate="item">
                      <div class="p-multiselect-representative-option">
                        <span class="ml-1">{{option.label}}</span>
                      </div>
                    </ng-template>
                  </p-multiSelect>
                </th>
              }
              <!-- Preview/Delete -->
              <th>
                <!-- to complete HH legacy functionality it should be present for move documents tab -->
                @if (!showChecked && previewColumnFilter) {
                  <p-multiSelect
                    appendTo="body"
                    placeholder="Filter"
                    scrollHeight="200px"
                    styleClass="p-column-filter"
                    [options]="documentCheckedOptions"
                    [(ngModel)]="appliedFilters.checkedByUserName.value"
                    (onChange)="filterTable($event.value, 'checkedByUserName', 'documentChecked')"
                    >
                    <ng-template let-option pTemplate="item">
                      <div class="p-multiselect-representative-option">
                        <span class="ml-1">{{option.label}}</span>
                      </div>
                    </ng-template>
                  </p-multiSelect>
                }
              </th>
              <!--Send to OCR-->
              <th>
              </th>
            </tr>
          }
        </ng-template>

        <ng-template let-rowData let-rowIndex="rowIndex" pTemplate="body">
          <tr [pSelectableRow]="rowData">
            <!-- Checkboxes -->
            @if (selectable) {
              <td alignFrozen="left" pFrozenColumn style="width: 3rem" [frozen]="true">
                <!-- Don't show button if source is EHR && !documentStorageLocation, inverse shown here for simplicity  -->
                @if (rowData.documentSource !== 'EHR' || rowData.documentStorageLocation) {
                  @if (rowData.documentSource === 'Letter' ? contextService.widgetFeatures.showLetterPreview : true) {
                    <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                  }
                }
              </td>
            }
            <!-- File Name -->
            <td alignFrozen="left" pFrozenColumn style="width: 20rem" [frozen]="true">
              <span class="inline-flex w-full justify-between items-center gap-2">
                @if (rowData.documentSource === 'EHR' && !rowData.documentStorageLocation) {
                  <div class="flex items-center w-full justify-between px-0 py-2">
                    <p class="truncate">{{ rowData['documentFileName'] }}</p>
                    <i
                      class="pi pi-exclamation-circle error-red"
                      pTooltip="Document Unavailable"
                      tooltipPosition="bottom"
                      tooltipStyleClass="tooltip-xl-size"
                    ></i>
                  </div>
                } @else {
                  @if (rowData.documentSource === 'Letter' ? contextService.widgetFeatures.showLetterPreview : true) {
                    <button
                      pButton
                      class="p-button-link inline-block text-left truncate p-0"
                      [class]="[
                        setWarningSign(rowData) ? 'w-[90%]' : 'w-full',
                        { 'visited-table-link': getClass(rowData.docMetaDataId) }
                      ]"
                      [label]="rowData['documentFileName']"
                      [title]="rowData['documentFileName']"
                      (click)="preview($event, rowData, rowIndex)"
                    ></button>
                  }

                  @if (rowData.documentSource === 'Letter' && !contextService.widgetFeatures.showLetterPreview) {
                    <div class="truncate px-0 py-2 w-[90%]">
                      {{ rowData['documentFileName'] }}
                    </div>
                  }

                  @if (setWarningSign(rowData)) {
                    <span
                      pButton
                      class="w-[10%] p-button-link px-0"
                      [ngClass]="{'visited-table-link': getClass(rowData.docMetaDataId)}"
                    >
                      <i
                        class="pi pi-exclamation-triangle exclamation-triangle"
                        pTooltip="Failed transmit to ICA"
                        tooltipPosition="bottom"
                        tooltipStyleClass="tooltip-xl-size"
                      ></i>
                    </span>
                  }

                  @if (rowData.phiFailed && allowedShowingPHIChecked) {
                    <i
                      class="pi pi-info-circle text-sm cursor-pointer"
                      pTooltip="PHI Check Failed"
                      tooltipPosition="bottom"
                    ></i>
                  }
                }
              </span>
            </td>
            <!-- Document Type: Send Fax Display -->
            @if (isFaxDisplay) {
              <td style="max-width: 10rem">
                <span
                  class="truncate"
                  tooltipStyleClass="tooltip-xxl-size"
                  tooltipPosition="top"
                  [pTooltip]="getDocumentTypeDisplayName(rowData['documentType'])"
                  >
                  {{ getDocumentTypeDisplayName(rowData['documentType']) }}
                </span>
              </td>
            }
            <!-- Source -->
            <td style="width: 9rem">
              {{ rowData['documentSource'] }}
            </td>
            <!-- Line Number -->
            <td style="max-width: 10rem">
              <span class="truncate" tooltipStyleClass="tooltip-xl-size" [pTooltip]="rowData['lineNumbers']">
                {{ rowData['lineNumbers'] ?? '--' }}
              </span>
            </td>
            <!-- Document Type: Document List Display -->
            @if (!isFaxDisplay) {
              <td style="max-width: 10rem">
                <span
                  class="truncate"
                  tooltipStyleClass="tooltip-xxl-size"
                  tooltipPosition="top"
                  [pTooltip]="getDocumentTypeDisplayName(rowData['documentType'])"
                  >
                  {{ getDocumentTypeDisplayName(rowData['documentType']) }}
                </span>
              </td>
            }
            <!-- Description -->
            @if (!isFaxDisplay) {
              <td style="width: 15rem">
                <span class="truncate" tooltipStyleClass="tooltip-xl-size" [pTooltip]="rowData['documentDescription']">
                  {{rowData['documentDescription']}}
                </span>
              </td>
            }
            <!-- Provider Type -->
            @if (isFaxDisplay) {
              <td style="width: 15rem">
                <span class="truncate" tooltipStyleClass="tooltip-xl-size" [pTooltip]="rowData['recipientType']">
                  {{rowData['recipientType']}}
                </span>
              </td>
            }
            <!-- Document Received Date/Time -->
            <td style="overflow: visible">
              <app-edit-date-time
                [authorizationByProductId]="authorizationByProductId"
                [data]="rowData"
                [showEdit]="!showDelete && !isFaxDisplay"
                [tenantId]="tenantId"
                (editEvent)="updateDocumentReceivedTime($event)">
              </app-edit-date-time>
            </td>
            <!-- Created By -->
            @if (!isExternal) {
              <td style="width: 17rem; max-width: 17rem;"> <!-- Created By -->
                <span class="truncate" tooltipStyleClass="tooltip-xl-size" [pTooltip]="rowData['createdBy']">
                  {{ rowData['createdBy'] }}
                </span>
              </td>
            }
            <!-- Document Checked -->
            @if (showChecked) {
              <td style="width: 16rem">
                <!-- Don't show button if source is EHR && !documentStorageLocation, inverse shown here for simplicity  -->
                @if (rowData.documentSource !== 'EHR' || rowData.documentStorageLocation) {
                  @if ((rowData.documentSource === 'Letter' ? contextService.widgetFeatures.showLetterPreview : true)) {
                    <div
                      tooltipPosition="bottom"
                      tooltipStyleClass="tooltip-xl-size"
                      pTooltip="{{ getLabel(rowData) }}"
                      [tooltipDisabled]="!rowData.checkedByUserName"
                    >
                      <button
                        aria-label="Check document"
                        class="max-w-full"
                        pButton
                        [pButtonPT]="{
                          buttonlabel: {
                            class: 'truncate'
                          }
                        }"
                        [disabled]="!contextService.widgetFeatures.checkDocument"
                        [icon]="rowData.checkedByUserName ? 'pi pi-times' : 'pi pi-check'"
                        [label]="getLabel(rowData)"
                        [ngClass]="rowData.checkedByUserName ? 'times-button' : 'check-button'"
                        (click)="showConfirmationCheckPopup(rowData)"
                      ></button>

                    </div>
                  }
                }
              </td>
            }
            <!-- Preview/Delete -->
            <td style="width: 12rem">
              <!-- Don't show button if source is EHR && !documentStorageLocation, inverse shown here for simplicity  -->
              @if (rowData.documentSource !== 'EHR' || rowData.documentStorageLocation) {
                @if ((rowData.documentSource === 'Letter' ? contextService.widgetFeatures.showLetterPreview : true)) {
                  <div class="inline-block m-0">
                    <button
                      aria-label="Preview document"
                      class="p-button-text mr-2"
                      icon="pi pi-external-link"
                      label="Preview"
                      pButton
                      type="button"
                      [ngClass]="{'p-table-button-clicked': getClass(rowData.docMetaDataId)}"
                      (click)="preview($event, rowData, rowIndex)"
                    >
                      <div class="pr-1">
                        @if (isLoading && rowIndex === selectedRowIndex) {
                          <i aria-hidden="true"
                          class="pi pi-spin pi-spinner"></i>
                        }
                      </div>
                    </button>
                    @if (contextService.widgetFeatures.deleteDocuments) {
                      @if (showDelete && isAllowedSource(rowData)) {
                        <button
                          aria-label="Delete document"
                          class="p-button-text ml-1"
                          icon="pi pi-trash"
                          pButton
                          type="button"
                          (click)="showDeleteDialog(rowData)"
                        ></button>
                      }
                    }
                  </div>
                }
              }
            </td>
            <!-- Send to ocr-->
            <td style="width: 12rem">
              <!--// Todo - 201538-->
              @if (isDocumentsTab && contextService?.widgetFeatures?.OCRService &&
                !isExternal && (rowData.documentSource === 'Upload' || rowData.documentSource === 'Inbound Faxes')) {
                <div
                  class="inline-block m-0">
                  <button
                    aria-label="Send to OCR"
                    class="p-button-text mr-2"
                    icon="pi pi-send"
                    label="Send to OCR"
                    pButton
                    type="button"
                    [disabled]="isOCRProcessing && rowIndex === selectedRowIndex"
                    [ngClass]="{'p-table-button-clicked': getClass(rowData.docMetaDataId)}"
                    (click)="sendToOcr(rowData, rowIndex)"
                    >
                    <div class="pr-1">
                      @if (isOCRProcessing && rowIndex === selectedRowIndex) {
                        <i aria-hidden="true"
                        class="pi pi-spin pi-spinner"></i>
                      }
                    </div>
                  </button>
                </div>
              }
            </td>

          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="11">No records found.</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft">
          <!-- empty but allows paginator to be pushed to the right -->
        </ng-template>
      </p-table>

      <p-dialog
        appendTo="body"
        header="Confirmation"
        [closable]="true"
        [maximizable]="false"
        [minY]="70"
        [modal]="true"
        [resizable]="false"
        [style]="{ width: '400px' }"
        [(visible)]="showDeleteModal"
      >
        <p>This document will be deleted. Do you wish to continue?</p>
        <ng-template #footer>
          <button
            aria-label="Cancel file delete"
            class="p-button-secondary"
            label="Cancel"
            pButton
            type="button"
            (click)="cancelDelete()"
          ></button>
          <button
            aria-label="Confirm file delete"
            label="Delete"
            pButton
            type="button"
            (click)="proceedDelete()"
          ></button>
        </ng-template>
      </p-dialog>
    </div>

<p-confirmDialog
  appendTo="body"
  key="confirm-check-document"
  [style]="{ width: '24.5rem' }"
/>
